import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  useProcedureRoomsStore,
  useSelectFormStore,
  useForm,
} from "../../../hooks";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  CancelButton,
  MainButton,
} from "../../ui";
import { useFormMessages } from "../../hooks";

const formData = {
  name: "",
  number: "",
  letter: "",
  headquarterId: "",
};

const formValidations = {
  name: [(value) => value.length > 0, "El nombre no puede ser vacio"],
  number: [(value) => value.length >= 0, "El numero puede ser vacio"],
  letter: [(value) => value.length >= 0, "La letra puede ser vacia"],
  headquarterId: [(value) => value.length > 0, "Selecciona una sede"],
};

export const ModalAddProcedureRoom = ({
  addProcedureRoom,
  setAddProcedureRoom,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    message,
    isLoading,

    // Methods
    starRegisterProcedureRoom,
  } = useProcedureRoomsStore();

  const { headquarters } = useSelectFormStore(["headquarters"]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  const { name, number, letter, headquarterId } = formState;

  const { nameValid, numberValid, letterValid, headquarterIdValid } =
    formValidation;

  // Funciones ---------------------------------------------//
  const onAddSurgeryRoom = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      starRegisterProcedureRoom(formState);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!addProcedureRoom) {
      setValidateForm(false);
      setFormSubmitted(false);
      onResetForm();
    }
  }, [addProcedureRoom]);

  useEffect(() => {
    if (showSuccessMessage) {
      setAddProcedureRoom(false);
    }
  }, [showSuccessMessage]);

  return (
    <Modal
      show={addProcedureRoom}
      onHide={() => {
        setAddProcedureRoom(false);
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Agregar Sala de procedimiento
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-6">
              <InputForm
                label={"Nombre"}
                type={"text"}
                placeholder={"Nombre"}
                validation={nameValid}
                submit={validateForm}
                name={"name"}
                value={name}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-3">
              <InputForm
                label={"Número"}
                sublabel={"Opcional"}
                type={"number"}
                placeholder={"Número"}
                validation={numberValid}
                submit={validateForm}
                name={"number"}
                value={number}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-3">
              <InputForm
                label={"Letra"}
                sublabel={"Opcional"}
                type={"text"}
                placeholder={"Letra"}
                validation={letterValid}
                submit={validateForm}
                name={"letter"}
                value={letter}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <SelectForm
                label={`Sede - ips`}
                options={headquarters}
                labelKey={"name"}
                validation={headquarterIdValid}
                submit={validateForm}
                name={`headquarterId`}
                value={headquarterId}
                onInputChange={onInputChange}
              />
            </div>
          </>
          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton
          type={"button"}
          onClick={() => setAddProcedureRoom(false)}
          disabled={isLoading}
        >
          Cancelar
        </CancelButton>
        <MainButton
          type={"button"}
          onClick={() => onAddSurgeryRoom()}
          disabled={isLoading}
        >
          Agregar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
